// Public marketing landing page (integrated from ureatrack-main).
// All styles are scoped under `.ut-landing` so they never affect the dashboard app.
import "./landing.css";
import Navbar from "./Navbar";
import HeroSlider from "./HeroSlider";
import About from "./About";
import Services from "./Services";
import Features from "./Features";
import WhyChooseUs from "./WhyChooseUs";
import CTABand from "./CTABand";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div className="ut-landing" data-testid="landing-page">
      <Navbar />
      <HeroSlider />
      <About />
      <Services />
      <Features />
      <WhyChooseUs />
      <CTABand />
      <Footer />
    </div>
  );
}
